@if (contractLoading) {
<div class="loading-container">
    <mat-spinner diameter="28"></mat-spinner>
</div>
} @else if (notFound) {
<div class="not-found-container">
    <mat-icon>search_off</mat-icon>
    <h2>Contract not found</h2>
    <p>This buy contract link is invalid or no longer exists.</p>
</div>
} @else if (contract) {
<div class="contract-info-container">
    <div class="contract-info">
        <div class="contract-header">
            <h2 class="contract-name">{{ contract.name || 'Buy Contract' }}</h2>
            <div class="contract-chips">
                <span [class]="'status-chip ' + getContractStatusClass(contract.status)">{{ contract.status }}</span>
                <span [class]="'payment-chip ' + (contract.payment_status === 'Payed' ? 'payed' : 'not-payed')">
                    <mat-icon>{{ contract.payment_status === 'Payed' ? 'check_circle' : 'pending' }}</mat-icon>
                    {{ contract.payment_status === 'Payed' ? 'Paid' : 'Unpaid' }}
                </span>
            </div>
        </div>

        @if (contract.note) {
        <p class="contract-note">{{ contract.note }}</p>
        }

        <div class="contract-stats">
            <div class="stat-item">
                <span class="stat-label">Target</span>
                <span class="stat-value">{{ contract.target_coins | number }}</span>
                <span class="stat-sub">{{ contract.target_type === 'sent' ? 'coins sent' : 'coins received' }}</span>
            </div>
            @if (contract.fee) {
            <div class="stat-divider"></div>
            <div class="stat-item">
                <span class="stat-label">Fee</span>
                <span class="stat-value">{{ contract.fee | number }}</span>
                <span class="stat-sub">Toman</span>
            </div>
            }
            @if (contract.fee_amount) {
            <div class="stat-divider"></div>
            <div class="stat-item">
                <span class="stat-label">Fee Amount</span>
                <span class="stat-value">{{ contract.fee_amount | number }}</span>
                <span class="stat-sub">coins</span>
            </div>
            }
            <div class="stat-divider"></div>
            <div class="stat-item">
                <span class="stat-label">Sent</span>
                <span class="stat-value">{{ contract.sent_coins | number }}</span>
                <span class="stat-sub">coins</span>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
                <span class="stat-label">Received</span>
                <span class="stat-value">{{ contract.received_coins | number }}</span>
                <span class="stat-sub">coins</span>
            </div>
        </div>

        <div class="progress-section">
            <div class="progress-header">
                <span class="progress-label">Progress</span>
                <span class="progress-percent">{{ progressPercent }}%</span>
            </div>
            <div class="progress-track">
                <div class="progress-fill" [style.width.%]="progressPercent" [class.complete]="progressPercent >= 100">
                </div>
            </div>
        </div>

        <div class="contract-times">
            @if (contract.started_at) {
            <div class="time-item">
                <mat-icon class="time-icon">play_circle_outline</mat-icon>
                <div class="time-content">
                    <span class="time-label">Started</span>
                    <span class="time-value">{{ formatDate(contract.started_at) }}</span>
                </div>
            </div>
            }
            @if (contract.finished_at) {
            <div class="time-item">
                <mat-icon class="time-icon">check_circle_outline</mat-icon>
                <div class="time-content">
                    <span class="time-label">Finished</span>
                    <span class="time-value">{{ formatDate(contract.finished_at) }}</span>
                </div>
            </div>
            }
        </div>

        @if (contract.failed_reason) {
        <div class="alert failed-alert">
            <mat-icon>error_outline</mat-icon>
            <div class="alert-body">
                <span class="alert-title">Failed</span>
                <span class="alert-sub">{{ contract.failed_reason }}</span>
            </div>
        </div>
        }
    </div>
</div>

<div class="cards-info-container">
    <div class="cards-header">
        <div class="section-label">Cards</div>
        <span class="spacer"></span>
        <button mat-icon-button (click)="load()" [disabled]="refreshing">
            @if (refreshing) {
            <mat-spinner diameter="18"></mat-spinner>
            } @else {
            <mat-icon>refresh</mat-icon>
            }
        </button>
    </div>

    <app-allocation-groups-list
        [allocations]="allocations"
        [loading]="allocationsLoading"
        [showHistory]="false"
        loadingText="Loading cards..."
        emptyMessage="No cards allocated to this contract yet.">
    </app-allocation-groups-list>
</div>
}
